import type { CalendarQuery } from "../../venue-api";

// Every venue-portal key starts with ["venue-portal", venueId] so a mutation can
// invalidate one venue's whole cache (or one slice of it) with a prefix.
export const venuePortalQueryKeys = {
	venuePortal: {
		all: () => ["venue-portal"] as const,
		calendar: (venueId: string, query: CalendarQuery) =>
			["venue-portal", venueId, "reservations", query] as const,
		closures: (venueId: string, from: string, to: string) =>
			["venue-portal", venueId, "closures", from, to] as const,
		courts: (venueId: string) => ["venue-portal", venueId, "courts"] as const,
		domains: (venueId: string) => ["venue-portal", venueId, "domains"] as const,
		hours: (venueId: string) => ["venue-portal", venueId, "hours"] as const,
		locationRequests: (venueId: string) => ["venue-portal", venueId, "location-requests"] as const,
		members: (venueId: string) => ["venue-portal", venueId, "members"] as const,
		photos: (venueId: string) => ["venue-portal", venueId, "photos"] as const,
		prices: (venueId: string) => ["venue-portal", venueId, "prices"] as const,
		profile: (venueId: string) => ["venue-portal", venueId, "profile"] as const,
		report: (venueId: string, from: string, to: string) =>
			["venue-portal", venueId, "report", from, to] as const,
		/** Every report range of a venue: what a booking change makes stale. */
		reports: (venueId: string) => ["venue-portal", venueId, "report"] as const,
		reservations: (venueId: string) => ["venue-portal", venueId, "reservations"] as const,
		venue: (venueId: string) => ["venue-portal", venueId, "venue"] as const,
		venues: () => ["venue-portal", "venues"] as const,
	},
} as const;
